
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mynews",
      function () {
        return require("private-next-pages/mynews/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mynews"])
      });
    }
  